import React from 'react'
import { Link, useLocation } from 'react-router-dom'

const Navbar = ({ darkMode, toggleDarkMode }) => {
  const location = useLocation()

  const navItems = [
    { path: '/tools', label: 'AI Tools', icon: '🛠️' },
    { path: '/companies', label: 'Companies', icon: '🏢' },
    { path: '/agents', label: 'Agents', icon: '👥' },
    { path: '/timeline', label: 'Timeline', icon: '⏰' },
    { path: '#subscribe', label: 'Subscribe', icon: '📬' }, // just '#subscribe' here
  ]

  const handleSubscribeClick = (e) => {
    e.preventDefault()
    const el = document.getElementById('subscribe')
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' })
      // Update URL hash without jumping
      history.pushState(null, '', '#subscribe')
    }
  }

  return (
    <nav
      className='glass-card sticky top-0 z-50 mx-2 sm:mx-4 mt-2 sm:mt-4 rounded-2xl'
      role='navigation'
      aria-label='Main navigation'
    >
      <div className='container mx-auto px-3 sm:px-6 py-3 sm:py-4'>
        <div className='flex items-center justify-between'>
          {/* Logo */}
          <Link
            to='/'
            className='flex items-center space-x-2 sm:space-x-3 group'
          >
            <div className='w-8 h-8 sm:w-10 sm:h-10 bg-gradient-to-r from-blue-500 to-purple-600 rounded-xl flex items-center justify-center shadow-lg group-hover:shadow-xl transition-all duration-300'>
              <span className='text-white font-bold text-sm sm:text-lg'>
                BAi
              </span>
            </div>
            <div className='hidden sm:block'>
              <h1 className='text-lg sm:text-xl font-bold text-white'>
                theBoomerAI
              </h1>
              <p className='text-xs text-white/70'>AI Directory</p>
            </div>
          </Link>

          {/* Navigation Links */}
          <div className='flex items-center space-x-1' role='menubar'>
            {navItems.map((item) =>
              item.path === '#subscribe' ? (
                <a
                  key={item.path}
                  href='#subscribe'
                  onClick={handleSubscribeClick}
                  className='px-2 sm:px-4 py-2 rounded-xl transition-all duration-300 flex items-center space-x-1 sm:space-x-2 text-white/80 hover:bg-white/10 hover:text-white min-h-[44px]'
                  role='menuitem'
                  title={item.label}
                >
                  <span className='text-base sm:text-lg' aria-hidden='true'>
                    {item.icon}
                  </span>
                  <span className='hidden md:inline font-medium text-sm'>
                    {item.label}
                  </span>
                </a>
              ) : (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`px-2 sm:px-4 py-2 rounded-xl transition-all duration-300 flex items-center space-x-1 sm:space-x-2 focus:outline-none focus:ring-2 focus:ring-white/50 focus:ring-offset-2 focus:ring-offset-transparent min-h-[44px] ${
                    location.pathname === item.path
                      ? 'bg-white/20 text-white shadow-lg'
                      : 'text-white/80 hover:bg-white/10 hover:text-white'
                  }`}
                  role='menuitem'
                  aria-current={
                    location.pathname === item.path ? 'page' : undefined
                  }
                  title={item.label}
                >
                  <span className='text-base sm:text-lg' aria-hidden='true'>
                    {item.icon}
                  </span>
                  <span className='hidden md:inline font-medium text-sm'>
                    {item.label}
                  </span>
                </Link>
              )
            )}
          </div>

          {/* Dark Mode Toggle */}
          <button
            onClick={toggleDarkMode}
            className='p-2 sm:p-3 rounded-xl bg-white/10 hover:bg-white/20 transition-all duration-300 text-white focus:outline-none focus:ring-2 focus:ring-white/50 focus:ring-offset-2 focus:ring-offset-transparent min-h-[44px] min-w-[44px] flex items-center justify-center'
            aria-label={
              darkMode ? 'Switch to light mode' : 'Switch to dark mode'
            }
            type='button'
          >
            {darkMode ? (
              <svg className='w-5 h-5' fill='currentColor' viewBox='0 0 20 20'>
                <path
                  fillRule='evenodd'
                  d='M10 2a1 1 0 011 1v1a1 1 0 11-2 0V3a1 1 0 011-1zm4 8a4 4 0 11-8 0 4 4 0 018 0zm-.464 4.95l.707.707a1 1 0 001.414-1.414l-.707-.707a1 1 0 00-1.414 1.414zm2.12-10.607a1 1 0 010 1.414l-.706.707a1 1 0 11-1.414-1.414l.707-.707a1 1 0 011.414 0zM17 11a1 1 0 100-2h-1a1 1 0 100 2h1zm-7 4a1 1 0 011 1v1a1 1 0 11-2 0v-1a1 1 0 011-1zM5.05 6.464A1 1 0 106.465 5.05l-.708-.707a1 1 0 00-1.414 1.414l.707.707zm1.414 8.486l-.707.707a1 1 0 01-1.414-1.414l.707-.707a1 1 0 011.414 1.414zM4 11a1 1 0 100-2H3a1 1 0 000 2h1z'
                  clipRule='evenodd'
                />
              </svg>
            ) : (
              <svg className='w-5 h-5' fill='currentColor' viewBox='0 0 20 20'>
                <path d='M17.293 13.293A8 8 0 016.707 2.707a8.001 8.001 0 1010.586 10.586z' />
              </svg>
            )}
          </button>
        </div>
      </div>
    </nav>
  )
}

export default Navbar
